<template>
    <div>
        <GmapMap ref="mapRef" :center="map_center" :zoom="12" style="width: 100%; height: 500px" :options="map_options">
            <GmapMarker :key="index" v-for="(m, index) in markers" :icon="m.icon" :position="m.position" :clickable="true" :draggable="false" @click="clickPharmacy(index)" :label="m.label"></GmapMarker>
        </GmapMap>
    </div>
</template>
<script>
import { gmapApi } from 'vue2-google-maps'
var numeral = require('numeral');

export default {
    props: ['pharmacies'],
    data: function() {
        return {
            map_center: { lat: 35.6010062, lng: -82.3977682 },
            map_options: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false
            },
            markers: []
        }
    },
    mounted: function() {

    },
    computed: {
        'google': gmapApi
    },
    methods: {
        'addMarker': function(lat, long, label, icon, ix) {
            var point = new this.google.maps.LatLng(lat, long);
            this.markers.push({
                position: point,
                label: label,
                icon: icon,
                index: ix
            })
        },
        fitBounds() {
            var b = new google.maps.LatLngBounds();
            this.markers.forEach(function(m) {
                b.extend(m.position);
            })
            this.$refs.mapRef.fitBounds(b);
        },
        formatCurrency(n) {
            return numeral(n).format('($0[.]00)');
        },
        clickPharmacy: function(ix) {
            this.$emit("openpanel", ix)
            this.map_center = this.markers[ix].position
        },
        updateMap: function(pharms) {
            this.markers = [];
            var g = this
            pharms.forEach(function(p, ix) {
                var label = {
                    text: g.formatCurrency(p.Price),
                    className: 'pharmacy-marker',
                    fontSize: "20px",
                    fontWeight: "Bold"
                }
                var icon = {
                    path: "M43.4-50.1h-87c-6.6,0-12,5.4-12,12v16c0,6.6,5.4,12,12,12h33.6l9.9,9.9l9.9-9.9h33.6c6.6,0,12-5.4,12-12v-16 C55.4-44.7,50-50.1,43.4-50.1z",
                    fillColor: '#ffffff',
                    fillOpacity: 1,
                    strokeColor: '#000000',
                    anchor: new g.google.maps.Point(0, 0),
                    strokeWeight: 1,
                    scale: .8,
                    labelOrigin: new g.google.maps.Point(0, -30),
                }
                g.addMarker(p.Lat, p.Long, label, icon, ix)
            })
            this.fitBounds()
        }
    },
    watch: {
        'pharmacies': function(newV) {
            this.updateMap(newV)
        }
    }
}
</script>
<style>
.pharmacy-marker {
    font-size: 30px;
}
</style>